import { render, staticRenderFns } from "./sigUsers.vue?vue&type=template&id=aa1a640a&scoped=true"
import script from "./sigUsers.vue?vue&type=script&lang=js"
export * from "./sigUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1a640a",
  null
  
)

export default component.exports